import { cn } from '@/lib/utils';
import { estimateProfit } from '@/utils/sale/profit';
import { OnboardingPrefs } from '../../stores/onboarding-prefs.store';

/** The earnings goal from the website's profit calculator; nothing when the leader didn't come from there */
export function OnboardingGoal({ prefs, className }: { prefs: OnboardingPrefs; className?: string }) {
  if (!prefs.participantCount || !prefs.itemsPerParticipant) return null;

  const profit = estimateProfit(prefs.participantCount, prefs.itemsPerParticipant);

  return (
    <div className={cn('rounded-lg bg-violet-500/10 px-4 py-2 text-center', className)}>
      <span className="text-sm">Ert mål: </span>
      <span className="font-bold text-primary">~{profit.toLocaleString('sv-se')} kr</span>
      <span className="block text-xs text-muted-foreground">
        {prefs.participantCount} deltagare × {prefs.itemsPerParticipant} produkter
      </span>
    </div>
  );
}
